import { Timestamp, collection, doc, updateDoc } from "firebase/firestore";
import { db } from "shared/api/firebase";
import { Page } from "../types";

type Params = {
  pageData: Partial<Page>;
  brandId: string;
  pageId: string;
};

export const updatePage = async ({
  pageData,
  pageId,
  brandId,
}: Params): Promise<void> => {
  const collectionRef = collection(db, `brands/${brandId}/pages`);
  await updateDoc(doc(collectionRef, pageId), {
    ...pageData,
    updatedAt: Timestamp.now(),
  });
};
